/* Keep Shopify's native follow action while matching the approved footer. */
(() => {
  const enhance = (container = document) => {
    container.querySelectorAll('.terence-restored-footer shop-follow-button').forEach(host => {
      let attempts = 0;
      const apply = () => {
        if (!host.isConnected || attempts++ > 40) return;
        const root = host.shadowRoot;
        if (!root?.querySelector('button')) { setTimeout(apply, 250); return; }
        if (root.querySelector('#terence-follow-style')) return;
        const style = document.createElement('style');
        style.id = 'terence-follow-style';
        style.textContent = `button{background:#8b1a1a!important;border-radius:4px!important;font-family:Arial,sans-serif!important}button>div.absolute{background:#8b1a1a!important;border-radius:4px!important}button:hover,button:hover>div.absolute{background:#701515!important}button>.px-2{display:none!important}button>span{padding:0 16px!important;font-size:13px!important;font-weight:700!important}button>span svg{height:13px!important}`;
        root.appendChild(style);
      };
      apply();
    });
  };
  customElements.whenDefined('shop-follow-button').then(() => enhance());
  document.addEventListener('shopify:section:load', () => enhance());
})();
